// TODO(RBAC, parent #641 #647): 権限チェックは別途実装
import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  getWorkflowCase,
  listWorkflowCases,
  listWorkflowTagPool,
  updateWorkflowCase,
} from '@ebalance/proto/bffuser/v1/workflow_case_service-WorkflowCaseService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * ケースの可変属性 (対象日 / 担当者 / タグ) を更新する mutation hook。
 * AC-TAG-003: タグの追加・削除はこの RPC 経由で即時保存される
 * (`UpdateWorkflowCaseRequest.tags` は full replace、FieldMask は無い)。
 * タグプール (AC-TAG-005) も invalidate する — 新規タグが org 全体のプールに
 * 加わりうるため、他画面のサジェスト・20 個上限チェックを最新化する。
 */
export function useUpdateWorkflowCase(
  caseId: string,
): InvalidatingMutationResultFor<typeof updateWorkflowCase> {
  return useInvalidatingMutation(updateWorkflowCase, [
    createConnectQueryKey({
      schema: getWorkflowCase,
      cardinality: 'finite',
      input: { id: caseId },
    }),
    createConnectQueryKey({ schema: listWorkflowCases, cardinality: 'finite' }),
    createConnectQueryKey({
      schema: listWorkflowTagPool,
      cardinality: 'finite',
    }),
  ])
}
